export default {
  home: {
    hero: {
      badge: 'تنسيق التوصيل بالوكلاء الأذكياء',
      title: 'وكلاء ذكاء اصطناعي يديرون عمليات التوصيل،',
      titleEnd: 'وفق القواعد التي تحددها.',
      description: 'تخطط Geofleet المسارات، وتوزع كل طلب، وتتتبع كل محطة مباشرة، وتلتقط إثبات التسليم. يتولى الوكلاء العمل الروتيني ضمن الحدود التي تضبطها، ولا يتدخل فريقك إلا عند الحاجة.',
      feedTitle: 'الوكلاء يعملون',
      feedLive: 'مباشر',
      feedFoot: 'نشاط توضيحي · ضمن حدودك',
      feedCta: 'شاهد الوكلاء',
      feed: [
        { text: 'وكيل الإرسال طابق ODR-78262 مع Amit Kumar', meta: 'درجة 92 · 3.1 كم · قبول خلال 6 ث' },
        { text: 'إعادة تخطيط 4 محطات حول طريق مغلق', meta: 'Hebbal · بقي الوصول ضمن النافذة' },
        { text: 'حارس SLA رصد المحطة 12 متأخرة 18 دقيقة', meta: 'اقتراح إعادة إسناد بانتظار الموافقة' },
        { text: 'إرسال أوقات وصول جديدة لعميلين عبر واتساب', meta: 'ODR-78251 · ODR-78264' },
        { text: 'التقاط إثبات التسليم: صورة وتوقيع وOTP', meta: 'ODR-78240 · Priya Nair · 2:14 م' },
        { text: 'تسوية 3 تحصيلات، 1 بانتظار المراجعة', meta: 'المنطقة الشمالية · ₹1,850 متبقية' },
      ],
      ctaPrimary: 'ابدأ مجاناً',
      ctaSecondary: 'احجز عرضاً',
      microTrust: 'تجربة مجانية لمدة 7 أيام على Lite · خطط من 39$ شهرياً',
      countries: 'أكثر من 20 دولة',
      customers: 'أكثر من 100 عميل',
      orders: 'معالجة أكثر من مليون طلب',
      industriesHeading: 'القطاعات التي نخدمها',
      trustedBy: 'تثق بنا فرق العمليات في أكثر من 20 دولة',
      imageAlt: 'مركز قيادة Geofleet للمنطقة الشمالية: 96% في الوقت، 24 سائقاً نشطاً، خريطة مباشرة بمحطتين متأخرتين، وCopilot يقترح نقل المحطتين 12 و14 إلى سائق قريب لديه سعة',
      phoneTrackingAlt: 'صفحة تتبع بعلامة العميل على هاتف مع خريطة مباشرة وبيانات السائق',
      phoneDriverAlt: 'شاشة تطبيق السائق في Geofleet مع مؤقت الوردية والرحلة الحالية',
      chipDelta: '+2% عن الأمس', chipCopilot: 'إصلاح يقترحه Copilot', chipCopilotText: 'إعادة إسناد محطتين متأخرتين · الوصول ضمن النافذة',
      chipCustomer: 'تم إشعار العميل', chipCustomerText: 'وقت وصول مباشر عبر الرسائل النصية وواتساب',
      cityAlt: 'منظر جوي لطريق سريع في مدينة وقت الغروب مع شاحنات وسيارات توصيل تسير على مسارات زرقاء متوهجة ومحطات مرقّمة',
      statOnTimeLabel: 'توصيلات في الوقت المحدد',
      statOnTimeValue: '96%',
      statCostLabel: 'تكلفة توصيل أقل',
      statCostValue: '20–30%',
      statRiderLabel: 'استخدام السائقين',
      statRiderValue: '+22%',
      capRoute: 'تحسين المسارات',
      capDispatch: 'التوزيع التلقائي',
      capTracking: 'التتبع المباشر',
      capPod: 'إثبات التسليم',
      trustedLine: 'تثق بنا أكثر من 100 فريق عمليات في أكثر من 20 دولة',
      statSource: 'نتائج من دراسات حالة العملاء',
      announceBadge: 'جديد',
      announceText: 'نقدم Geofleet Command: وكلاء ذكاء اصطناعي مهيؤون لشبكتك',
      announceCta: 'عرض الخطط',
      proofSecurity: 'حاصل على SOC 2 وISO 27001',
      costLine: 'خفض في تكلفة التوصيل، وفق دراسات حالة العملاء',
      chooser: {
        subtitle: 'اختر الخيار الذي يناسب عملياتك.',
        close: 'إغلاق',
        title: 'من أين توصل طلباتك؟',
        liteTitle: 'موقع واحد وحتى 25 سائقاً',
        liteText: 'Geofleet Lite · تجربة مجانية لمدة 7 أيام، ثم من 39$ شهرياً',
        commandTitle: 'عدة مواقع أو أكثر من 25 سائقاً',
        commandText: 'Geofleet Command · وكلاء ذكاء اصطناعي ومسارات عمل قابلة للضبط، من 19$ لكل سائق',
      },
    },
    proofBar: {
      stats: [
        { value: '100+', label: 'عملاء' },
        { value: '20+', label: 'دول' },
        { value: '95%', label: 'معدل الالتزام بالمواعيد' },
        { value: '99.99%', label: 'وقت التشغيل' },
        { value: '50+', label: 'تكاملات' },
      ],
    },
    exceptionStory: {
      eyebrow: 'مركز القيادة + Copilot',
      title: 'سائق متأخر، يُعالَج تلقائياً',
      subtitle: 'يرصد Geofleet المشكلة ويُعدّ الحل ويُبلغ الجميع. لا يتدخل فريقك إلا للموافقة.',
      steps: [
        {
          title: 'رصد تلقائي',
          body: 'بمجرد أن يتأخر سائق، يحدّد Geofleet المحطات المعرّضة للخطر وينقلها إلى أعلى القائمة. لا حاجة لأن يبحث عنها أحد.',
        },
        {
          title: 'شرح، لا مجرد تنبيه',
          body: 'يوضّح Copilot للفريق ما المتأخر وسبب التأخير، مثل الازدحام على الطريق الدائري. ويمكن لأي شخص طرح سؤال متابعة بلغة بسيطة.',
        },
        {
          title: 'حل جاهز لك',
          body: 'يجد أقرب سائق لديه سعة متاحة ويُعدّ إعادة الإسناد مع أوقات الوصول الجديدة، جاهزة للموافقة بلمسة واحدة أو للتنفيذ تلقائياً ضمن ضوابطك.',
        },
        {
          title: 'تحديث الجميع تلقائياً',
          body: 'يتحدّث تطبيقا السائقَين، ويتلقى العملاء وقت وصول جديداً عبر SMS أو WhatsApp، ويُسجَّل التغيير. دون مكالمات أو رسائل ترسلها بنفسك.',
        },
      ],
      /** Labels on the screenshot for each step (sample data). */
      annotations: [
        { status: 'تم رصد الخطر تلقائياً', detail: 'المحطة 12 · تأخير 18 دقيقة' },
        { status: 'ملخص Copilot', detail: 'السبب: ازدحام على الطريق الدائري' },
        { status: 'الحل جاهز للموافقة', detail: 'نقل 2 من المحطات إلى Amit Kumar' },
        { status: 'تم التنفيذ تلقائياً', detail: 'تم إشعار العملاء عبر WhatsApp' },
      ],
      footnote: 'اختر ما يُنفَّذ تلقائياً وما ينتظر الموافقة. ويُسجَّل كل إجراء.',
      cta: 'اكتشف وكلاء الذكاء الاصطناعي',
      /** Caption under the step screenshots, which use illustrative data. */
      mock: { sample: 'بيانات تجريبية' },
    },
    platformCapabilities: {
      eyebrow: 'المنصة',
      title: 'قدرات منصة',
      titleHighlight: 'على مستوى المؤسسات',
      subtitle: 'تخطط Geofleet كل عملية توصيل وترسلها وتتبعها وتثبتها من منصة واحدة. اختر قدرة لتراها داخل المنتج.',
      explore: 'استكشف',
      prev: 'القدرة السابقة',
      next: 'القدرة التالية',
      pause: 'إيقاف مؤقت',
      play: 'تشغيل',
    },
    industryImpact: {
      eyebrow: 'قصص العملاء',
      title: 'أثر مثبت في',
      titleHighlight: 'كل القطاعات الرئيسية',
      subtitle: 'المطاعم والبقالة والصيدليات وشبكات الطرود وشركات 3PL تعمل على Geofleet. كل قصة أدناه لعميل حقيقي، أُبقي مجهولاً بناءً على طلبه.',
      challenge: 'التحدي',
      solution: 'الحل',
      readCaseStudy: 'اقرأ دراسة الحالة',
      industryPage: 'Geofleet لهذا القطاع',
      allCaseStudies: 'عرض كل دراسات الحالة',
    },
    whyGeofleet: {
      eyebrow: 'لماذا Geofleet',
      title: 'لماذا تختار فرق التوصيل',
      titleHighlight: 'Geofleet',
      subtitle: 'مركز قيادة يديره وكلاء ذكاء اصطناعي فوق أدوات الإثبات والنقد والسائقين التي تحتاجها أصلاً، مع أرقام تدعمه.',
      items: {
        dispatch: { title: 'إرسال يعمل من تلقاء نفسه', body: 'وكيل يعمل على مدار الساعة يطابق كل طلب مع سائق أو ناقل في ثوانٍ ويعرضه في تطبيق السائق. لا يرى المرسلون سوى الاستثناءات.' },
        onTime: { title: 'في الوقت المحدد، كل يوم', body: 'أوقات وصول مباشرة وإعادة مطابقة عند كل حدث وتنبيهات SLA تبقي المسارات في موعدها عندما يخرج اليوم عن الخطة.' },
        cost: { title: 'تكلفة أقل لكل توصيلة', body: 'مسارات أكثر امتلاءً ومحاولات فاشلة أقل وبلا جهد إرسال يدوي تخفض 20 إلى 30% من تكلفة كل محطة.' },
        reliability: { title: 'مبني للتوسع والتدقيق', body: 'SOC 2 وISO 27001 وجاهزية 99.99% وسجل قرار لكل إسناد، لتثق العمليات والمالية بالأرقام.' },
        integrations: { title: 'يتوافق مع أنظمتك الحالية', body: 'الطلبات من متجرك أو ERP، التحديثات عبر واتساب والرسائل النصية، والنقد مطابق مع دفاترك. بيئة اختبار وWebhooks وAPI للباقي.' },
        global: { title: 'جاهز لكل سوق', body: 'فرق في أكثر من 20 دولة تستخدم Geofleet مع لوحة التحكم وتطبيق السائق بأربع لغات وأسعار بالعملة المحلية.' },
      },
      labels: { order: 'طلب', matched: 'مطابق', accepted: 'مقبول', onTimeRate: 'نسبة الالتزام بالوقت', lowerCost: 'تكلفة أقل لكل توصيلة', manual: 'يدوي', uptime: 'الجاهزية', integrations: 'تكاملات', countries: 'دولة' },
    },
    integrationsHub: {
      eyebrow: 'التكاملات',
      title: 'متصل بسلاسة مع',
      titleHighlight: 'أكثر من 50 تكاملاً أصلياً',
      subtitle: 'تتدفق الطلبات من متجرك أو نقاط البيع أو ERP، وتخرج التحديثات إلى العملاء، ويُسوّى النقد مع دفاترك. ويتيح Model Context Protocol لأدوات الذكاء الاصطناعي الخاصة بك العمل على البيانات نفسها.',
      hubLabel: 'مركز القيادة',
      categories: { commerce: 'التجارة ومصادر الطلبات', erp: 'ERP والمحاسبة وCRM', automation: 'الأتمتة والذكاء الاصطناعي', messaging: 'الرسائل النصية والبريد', payments: 'المدفوعات وتنبيهات الفريق', maps: 'الخرائط وشركات الشحن' },
      soon: 'قريباً',
      cta: 'تصفح كل التكاملات',
      apiDocs: 'توثيق API',
    },
    lifecycle: {
      eyebrow: 'كيف يعمل',
      title: 'ست خطوات من الطلب إلى إثبات التسليم',
      cta: 'شاهد كيف يعمل',
      scrollHint: 'مرّر لتتبّع طلب واحد من الاستيراد حتى إثبات التسليم.',
      /** Status pill and detail chip shown on the visual for each step (sample data). */
      annotations: [
        { status: 'جارٍ استيراد الطلبات', detail: '312 طلباً · 3 تحتاج إلى مراجعة' },
        { status: 'تم تحسين المسارات', detail: '4 مسارات · 312 محطة مخططة' },
        { status: 'تم الإرسال', detail: 'أُرسل المسار إلى تطبيق Amit Kumar' },
        { status: 'مباشر على الخريطة', detail: 'أُعيد ترتيب المحطة 12 · وقت الوصول 11:38 AM' },
        { status: 'تم إشعار العميل', detail: 'أُرسل رابط التتبع عبر WhatsApp' },
        { status: 'تم التسليم', detail: 'تم توثيق الصورة والتوقيع ورمز OTP' },
      ],
      stepShort: ['استيراد', 'تخطيط', 'إرسال', 'تتبّع', 'إشعار', 'إثبات'],
    },
    industryTabs: {
      eyebrow: 'مصمم لقطاعك',
      title: 'منصة واحدة، مهيأة لطريقة توصيلك',
      cta: 'استكشف {{industry}}',
      all: 'كل القطاعات',
    },
    pricingTeaser: {
      eyebrow: 'الأسعار',
      title: 'السعر معروض على الصفحة',
      subtitle: 'يبدأ كلاهما بسعر شهري يشمل السائقين والطلبات. يدير Lite موقعاً واحداً بخطة ثابتة، ويتوسع Command لكل سائق عبر مواقع متعددة.',
      perDriver: '/سائق/شهر',
      compare: 'قارن الخطط',
      startFree: 'ابدأ الآن',
    },
    problemSection: {
      eyebrow: 'واقع آخر ميل',
      title: 'الإسناد اليدوي يقوّض كفاءة آخر ميل',
      subtitle:
        'عندما يعيش التوزيع في المحادثات والمكالمات والجداول، تظهر هذه النتائج حتماً—وتتفاقم مع كل ذروة.',
      pains: [
        {
          title: 'تأخير التوصيل',
          description:
            'تنتظر الطلبات قراراً بشرياً بينما يتحرك المرور والسعة واتفاقيات مستوى الخدمة—فتراكم التأخير وفرار العملاء.',
        },
        {
          title: 'سائقون غير مستغَلّين',
          description:
            'تبقى سعة غير مستخدمة في منطقة بينما يرتفع الطلب في أخرى لأن الإسناد لا يعيد التوزيع بسرعة كافية.',
        },
        {
          title: 'إرهاق المُنسّقين',
          description:
            'في الذروات يتحول الفريق إلى تبديل يدوي: الفرز وإعادة الإسناد يستهلكان ساعات كان يفترض أن تتوسع تلقائياً.',
        },
        {
          title: 'أوقات وصول غير متسقة',
          description:
            'تنحرف النوافذ الموعودة عن الواقع عندما لا ترتبط الخطط بالموقع المباشر وحمل العمل وحالة المسار.',
        },
        {
          title: 'عدم كفاءة تشغيلية',
          description:
            'يرتفع تكلفة المحطة: أميال إضافية وعمل إضافي واستثناءات بدلاً من تنفيذ مُحسَّن ومتكرر.',
        },
      ],
    },
    outcomes: {
      eyebrow: 'نتائج — ليس قوائم ميزات',
      title: 'ما الذي يتغير عندما يعمل الإسناد في الوقت الفعلي',
      subtitle:
        'تعتمد الفرق على Geofleet لتحريك مؤشرات أداء حقيقية: تقليل التأخير، رفع إشغال المسارات، وترك المُنسّقين للاستثناءات لا لجداول يدوية.',
      items: [
        {
          headline: '30%',
          trend: 'down',
          title: 'تأخير التوصيل',
          sub: 'انخفاض حوادث التأخير مقارنة بالإسناد اليدوي.',
        },
        {
          headline: '25%',
          trend: 'up',
          title: 'استخدام السائقين',
          sub: 'محطات أوفر عندما تطابق الطلبات السعة المباشرة.',
        },
        {
          headline: '80%',
          trend: 'down',
          title: 'الجهد اليدوي للإسناد',
          sub: 'وقت أقل لإعادة الإسناد والمكالمات في الذروات.',
        },
        {
          headline: 'في الوقت',
          trend: 'up',
          title: 'معدل التوصيل',
          sub: 'التزام أفضل باتفاقيات مستوى الخدمة عندما تعكس أوقات الوصول حالة المسار.',
        },
      ],
    },
    roiCalculator: {
      eyebrow: 'لمحة عائد الاستثمار',
      title: 'قدّر وفوراتك الشهرية',
      subtitle:
        'نموذج سريع من حجمك وأسطولك وتكلفة التأخير—حسّن النموذج مع فريقنا على شبكتك الفعلية.',
      ordersLabel: 'طلبات يومياً',
      ridersLabel: 'سائقون / رايدرز',
      delayCostLabel: 'متوسط تكلفة التأخير لكل طلب ($)',
      ordersHelp: 'متوسط حجم الطلبات اليومية التي تُسنَّد.',
      ridersHelp: 'السائقون النشطون في آخر ميل.',
      delayCostHelp: 'تكلفة متوسطة للتأخير أو توصيل دون أداء مثالي.',
      outputLabel: 'الوفورات الشهرية المقدرة',
      breakdownDelays: 'من تقليل التأخير (30%)',
      breakdownUtil: 'من رفع الاستخدام (25%)',
      breakdownManual: 'من تقليل الإسناد اليدوي (80% من الجهد النموذجي)',
      disclaimer:
        'للتوضيح فقط—ليس استشارة مالية ولا ضماناً. تعتمد النتائج على الشبكة واتفاقيات مستوى الخدمة والتبني. احجز عرضاً لنموذج مخصص.',
      cta: 'احجز عرضاً للتحقق',
      ctaSecondary: 'التحدث إلى المبيعات',
    },
    aiAgents: {
      eyebrow: 'وكلاء ذكاء اصطناعي للوجستيات',
      title: 'يرسلون ويعيدون التوجيه ويحلون — قبل أن يضطر فريقك',
      intro:
        'ينشر Geofleet سير عمل وكيلية في برج التحكم: يطابق الناقلين والسائقين في الوقت الفعلي، تعاد جدولة المسارات عند تغير المرور أو الحجم، ويظهر خطر SLA مع السياق — حتى لا يحد النمو عن سير عمل يدوي للإرسال.',
      cta: 'استكشف وكلاء الذكاء الاصطناعي',
    },
    trust: {
      title: 'برج تحكم واحد. وكلاء ذكاء اصطناعي للعمل الثقيل.',
      subtitle: 'أتمتة القرارات التي كانت تستهلك ساعات الإرسال — دون استبدال كامل مكدسك التقني.',
      benefits: [
        {
          title: 'إرسال وتعيين وكيلي',
          description:
            'يطابق الوكلاء كل شحنة بالناقل والسائق المناسبين حسب السعة والتكلفة وSLA والمهارات والظروف المباشرة — باستمرار، وليس دفعات ليلية.',
        },
        {
          title: 'مسارات تعيد تخطيط نفسها',
          description:
            'عند تغير المرور أو فشل محاولة أو وصول طلبات أثناء الطريق، يتكيف التخطيط الوكيلي دون إعادة بناء الجولات في جداول.',
        },
        {
          title: 'استثناءات تُعالج في البرج',
          description:
            'تنبيهات استباقية لخطر SLA والتأخير وضغط السعة — بأولوية ذكاء اصطناعي ليعالج البشر الأهم بينما الوكلاء ينظفون الباقي.',
        },
        {
          title: 'رؤية يثق بها التنفيذ والعملاء',
          description:
            'أوقات وصول متوقعة وتتبع بعلامتكم وخرائط مباشرة من نفس النموذج الوكيلي الذي يستخدمه الإرسال — نسخة واحدة من الحقيقة.',
        },
      ],
    },
    howItWorks: {
      badge: 'مركز القيادة',
      title: 'برج واحد',
      titleHighlight: 'للمحادثة والقيادة',
      subtitle:
        'كل شيء يحدث في مركز القيادة: تحدّث مع Copilot للتخطيط والإصلاح، ودعه ينفّذ إجراءات جماعية، وأكمل الإطلاق بإعداد بمساعدة الذكاء الاصطناعي—دون التنقل بين الأدوات.',
    },
    howItWorksBlocks: {
      pillarsSectionEyebrow: 'كيف يعمل',
      pillarsSectionTitle: 'سطحان—وليس قائمة ميزات طويلة',
      pillarsIntro:
        'ما يلي مقسوم إلى مركز القيادة (عمليات مباشرة) وCopilot (ذكاء اصطناعي على نفس البيانات). أربع قدرات مضغوطة لكل منهما—سهل المسح.',
      flowSectionTitle: 'كيف يرتبط المسار',
      flowSectionIntro: 'البرج أولاً ثم Copilot ثم التنفيذ والإعداد الموجّه—نفس القصة خطوة بخطوة.',
      steps: {
        commandCentre: 'مركز القيادة',
        copilot: 'Copilot',
        execute: 'التنفيذ والأتمتة',
        aiOnboarding: 'إعداد بالذكاء الاصطناعي',
      },
      stepBlurbs: {
        commandCentre: 'خريطة مباشرة وطوابير وتحكم—سطح واحد للعملية بأكملها.',
        copilot: 'اطلب بلغة بسيطة: تعيين المسارات وحل الاستثناءات وحالة التنفيذ.',
        execute: 'حوّل الإجابات إلى تحديثات جماعية وإعادة توجيه وسير عمل دون التنقل بين التبويبات.',
        aiOnboarding: 'إعداد موجّه للتكاملات والمراكز والأدوار—Copilot يرافق فريقك.',
      },
      majorFeatures: [
        {
          kicker: 'العمليات',
          title: 'مركز القيادة',
          subtitle:
            'عرض مباشر واحد لكل طلب وسائق ومحطة، مع المقاييس وسجل التدقيق من ورائها.',
          cards: [
            {
              title: 'خريطة وطوابير مباشرة',
              line: 'شاهد المُسلَّم وقيد النقل والمعرّض للخطر معاً—تصعد الاستثناءات للأعلى.',
            },
            {
              title: 'اربط بنيتك',
              line:
                'تكاملات أصلية وMCP لأدوات الذكاء الاصطناعي وCSV بالجملة أو إدخال يدوي—سائقون ومركبات ومراكز وطلبات.',
            },
            {
              title: 'خطط وغيّر بسرعة',
              line: 'إرسال وإعادة تعيين وتحديثات جماعية وقوائم شحن حيث تسمح السياسة.',
            },
            {
              title: 'رؤى وتدقيق',
              line: 'مؤشرات وتفصيل التأخيرات؛ تصدير وسجل لتجربة العميل والمالية والامتثال.',
            },
          ],
        },
        {
          kicker: 'أتمتة بالذكاء الاصطناعي',
          title: 'Copilot ووكلاء الذكاء الاصطناعي',
          subtitle:
            'يراقبون العمليات المباشرة ويُعدّون الحلول ويتصرفون ضمن ضوابطك، فتُحَلّ الاستثناءات الروتينية من تلقاء نفسها.',
          cards: [
            {
              title: 'رصد المشكلات مبكراً',
              line: 'يتم تنبيهك إلى السائقين المتأخرين ومحاولات التسليم الفاشلة ومخاطر SLA لحظة حدوثها.',
            },
            {
              title: 'إعداد الحل',
              line: 'إعادة الإسناد وإعادة التوجيه وتحديثات العملاء جاهزة للموافقة بلمسة واحدة.',
            },
            {
              title: 'التصرف ضمن الضوابط',
              line: 'الإجراءات الروتينية تُنفَّذ وحدها، وكل ما يتجاوز حدودك يعود إلى شخص.',
            },
            {
              title: 'شرح عند الطلب',
              line: 'اسأل «ماذا تغيّر منذ 09:00؟» واحصل على إجابات من البيانات المباشرة، لا نص ذكاء اصطناعي عام.',
            },
          ],
        },
      ],
      seeInAction: 'شاهدها في العمل',
      howItWorksLink: 'كيف يعمل',
      bottomCtaTitle: 'مستعد لإدارة توصيلاتك بطريقتك؟',
      bottomCtaSub: 'نظرة واحدة لتجربة العميل والعمليات — بدون جداول.',
    },
    platformCarousel: {
      badge: 'برج التحكم',
      title: 'شاهد Geofleet أثناء العمل',
      subtitle: 'نفس الواجهة التي يستخدمها الوكلاء: إرسال، خريطة مباشرة، مسارات وتحليلات في مكان واحد.',
      slides: [
        { title: 'لوحة الإرسال', description: 'مركز يعيّن فيه الوكلاء والمشغّلون ويعيدون التوازن ويعالجون الاستثناءات مباشرة' },
        { title: 'تخطيط المسارات', description: 'توجيه وكيلي يتفاعل مع الزحام والنوافذ والحجم — فوق ملفات مسارات ثابتة' },
        { title: 'تتبع العملاء', description: 'تتبع بعلامتكم وأوقات وصول من نفس النموذج المباشر لبرجكم' },
        { title: 'التحليلات والتقارير', description: 'شاهد ما نقله الوكلاء والسائقون — وأين استعادت الأتمتة الوقت والهامش' },
      ],
    },
    transformation: {
      badge: 'التحول',
      title: 'ما يقدمه Geofleet لعملياتك',
      titleHighlight: 'اللوجستية',
      subtitle: 'من سير العمل اليدوي والمجزأ إلى برج تحكم مدعوم بالذكاء الاصطناعي — شاهد الفرق.',
      withoutGeofleet: 'بدون Geofleet',
      withGeofleet: 'مع Geofleet',
      controlTower: 'برج تحكم مدعوم بالذكاء الاصطناعي',
      exploreFeatures: 'استكشف الميزات',
      beforeItems: [
        'ساعات تُقضى في الإرسال اليدوي وتخطيط المسارات',
        'لا رؤية فورية — العملاء والعمليات في الظلام',
        'جداول بيانات وأدوات متعددة لا تتكامل',
        'توصيلات متأخرة وإثبات توصيل فاشل ونزاعات',
        'تسرب إيرادات من الدفع عند الاستلام والاستردادات وعدم الكفاءة',
      ],
      afterItems: [
        'وكلاء الذكاء الاصطناعي يرسلون ويحسّنون المسارات في ثوانٍ',
        'تتبع مباشر ووقت وصول متوقع وصفحات تتبع بعلامتك التجارية',
        'برج تحكم واحد للأسطول والطلبات والتحليلات',
        'ePOD وتوقيع إلكتروني وOTP — نزاعات أقل وإثبات جاهز للتدقيق',
        'استرداد الإيرادات وخفض التكاليف والتوسع بثقة',
      ],
      joinTeams: 'انضم للفرق التي حققت التحول',
      stat1: 'انخفاض التكلفة 20–30%',
      stat2: 'توصيل في الوقت 95%',
      stat3: 'صفر إرسال يدوي',
    },
    scaleImpact: {
      title: 'عمليات الأسطول تعمل على',
      titleBrand: 'Geofleet',
      subtitle: 'من مركز واحد إلى أساطيل متعددة الدول — وكلاء ذكاء اصطناعي وبشر في برج آخر ميل واحد.',
      stats: [
        { label: 'معدل التوصيل في الوقت' },
        { label: 'انخفاض التكلفة' },
        { label: 'كفاءة السائق' },
        { label: 'عمليات مدعومة بالذكاء الاصطناعي' },
      ],
      multiRegion: 'متعدد المناطق',
      enterpriseReady: 'جاهز للمؤسسات',
      integrations: 'أكثر من 50 تكاملاً',
    },
    trustedLeaders: {
      badge: 'موثوق به من قادة الصناعة',
      title: 'فرق المؤسسات تعمل على',
      titleBrand: 'Geofleet',
      subtitle: 'من الشركات الناشئة سريعة النمو إلى لوجستيات فورتشن 500 — شركات تعالج ملايين التوصيلات تثق بـ Geofleet لتشغيل عملياتها.',
      testimonials: [
        { quote: 'أزال إرسال Geofleet بالذكاء الاصطناعي معظم التوجيه اليدوي. وسّعنا توصيلات الوصفات اليومية دون إضافة مشغّلين — تحسّن الامتثال والتوصيل في الوقت عبر اللوحة.', author: 'قائد العمليات', role: 'صيدلية', company: 'قطر', metric: 'توصيلات موسّعة' },
        { quote: 'قلّل محرك ETA التنبؤي مكالمات شكاوى العملاء بشكل كبير. عملاؤنا المؤسسيون يعتبروننا الآن الأفضل في التوصيل لآخر ميل في المنطقة.', author: 'رئيس اللوجستيات', role: 'شركة لوجستيات توصيل', company: 'الإمارات', metric: '70% شكاوى أقل' },
        { quote: 'دمجنا Geofleet في فرق الميدان خلال أسابيع. المنصة تتولى الإرسال ومراقبة السائقين وإثبات التوصيل لنركز على وقت التشغيل والأمان.', author: 'مدير الأسطول', role: 'شركة طاقة متجددة', company: 'الهند', metric: 'نشر أسرع' },
      ],
      stats: [
        { value: '100+', label: 'عملاء' },
        { value: '1M+', label: 'توصيلات معالجة' },
        { value: '20+', label: 'دول' },
        { value: '99.99%', label: 'وقت تشغيل المنصة' },
        { value: '24/7', label: 'دعم المؤسسات' },
      ],
      badges: [
        { label: 'متوافق مع SOC 2' },
        { label: 'جاهز لـ GDPR' },
        { label: 'SLA 99.99%' },
        { label: 'SSO' },
        { label: 'API-First' },
      ],
    },
    driverExperience: {
      badge: 'تجربة السائق',
      title: 'تطبيق سائق سيحبونه',
      titleHighlight: 'فعلاً',
      subtitle: 'مصمم للسرعة والبساطة. كل ما يحتاجه السائق لإتمام التوصيلات أسرع — ولا شيء أكثر.',
      features: [
        { title: 'مسارات محسّنة بالذكاء الاصطناعي', description: 'ملاحة خطوة بخطوة مع تحويلات مرورية فورية. السائقون يسلكون دائماً أسرع مسار.', stat: 'أسرع 30%' },
        { title: 'إثبات توصيل ذكي', description: 'صور معتمدة بالذكاء الاصطناعي وتوقيع إلكتروني وتأكيد OTP — كل ذلك بنقرة واحدة.', stat: 'POD بنقرة' },
        { title: 'قائمة مهام ذكية', description: 'الذكاء الاصطناعي يرتب التوقفات حسب الأولوية والفواصل الزمنية والقرب. بدون تخمين وبدون تفويت SLAs.', stat: '95% في الموعد' },
        { title: 'التواصل داخل التطبيق', description: 'مكالمات بنقرة وأرقام مخفية ومحادثة مع المشغّل — دون مغادرة التطبيق.', stat: 'بدون احتكاك' },
        { title: 'مسح الباركود والهوية', description: 'مسح باركود الطرود والتحقق من هوية العميل للتوصيلات ذات القيود العمرية أو القيمة العالية.', stat: '100% موثق' },
        { title: 'يعمل دون اتصال', description: 'وظائف كاملة في المناطق الميتة. المزامنة تلقائية عند عودة الاتصال.', stat: 'دائماً يعمل' },
      ],
      delivered: 'تم التوصيل',
      orderId: '#1246',
      rating: 'التقييم',
      ratingValue: '4.9/5',
      availableOn: 'متاح على iOS وAndroid',
      downloadOnThe: 'تنزيل من',
      appStore: 'App Store',
      getItOn: 'احصل عليه من',
      googlePlay: 'Google Play',
      appStoreRating: '4.9 على App Store',
    },
    coreFeatures: {
      badge: 'ذكاء اصطناعي + منصة',
      title: 'شاهد Geofleet أثناء العمل',
      subtitle: 'إرسال، وتوجيه وكيلي، وتتبع، وتحليلات — كل ما يحتاجه الوكلاء والفرق في مكدس واحد.',
      platformLine: 'عمق المنتج ورؤية مؤسسية — وكلاء وبشر على نفس البيانات المباشرة.',
      carousel: {
        dispatch: 'الإرسال',
        routes: 'المسارات',
        tracking: 'التتبع',
        analytics: 'التحليلات',
        dispatchHeadline: 'مركز واحد لكل الطلبات والسائقين',
        dispatchDescription: 'أدر الإرسال من شاشة واحدة — عيّن السائقين، حدّث الحالة، وتعامل مع الاستثناءات في الوقت الفعلي. لا مزيد من الجداول أو الطلبات الفائتة.',
        routesHeadline: 'مسارات محسّنة بالذكاء الاصطناعي في ثوانٍ',
        routesDescription: 'محركنا يأخذ في الاعتبار الزحام ونوافذ الوقت والسعة لتقليل الأميال والوقود. توصيل محطات أكثر في كل جولة بتخطيط أقل.',
        trackingHeadline: 'تتبع باسم علامتك، خريطة حية ووقت الوصول',
        trackingDescription: 'امنح كل عميل صفحة تتبع بشعارك وخريطة حية. مكالمات "أين طلبي؟" أقل ومراجعات أفضل.',
        analyticsHeadline: 'رؤى تدفع أداءً أفضل',
        analyticsDescription: 'أوقات التوصيل، معدلات الالتزام بالمواعيد، بطاقات أداء السائقين، والتكلفة لكل توصيلة — كل ذلك في لوحات تساعدك على التحسين أسبوعياً.',
      },
      learnMore: 'اعرف المزيد',
      whatIncluded: 'ما المدرج',
      stats: { eta: 'دقة ETA', savings: 'توفير المسارات', disputes: 'نزاعات أقل' },
      ctaDemo: 'احجز عرضاً',
      ctaTrial: 'ابدأ الآن',
      pillarsCrossLink:
        'مركز القيادة وCopilot مفسّران في قسم «كيف يعمل» أعلاه — هذا العرض يمر على أربع شاشات رئيسية للمنتج.',
      pillarsCrossLinkCta: 'الانتقال إلى كيف يعمل',
    },
    integrations: {
      label: 'التكاملات',
      title: 'Model Context Protocol لمكدس التوصيل لديك',
      paragraph:
        'يدعم Geofleet بروتوكول MCP حتى تعمل المساعدات والوكلاء مع سياق منظم وبصلاحيات مناسبة لعملياتك، إلى جانب موصلات أصلية لأكثر من 10 SMS وأكثر من 10 بريد وأكثر من 10 بوابات دفع وأكثر من 5,000 جهاز IoT وأكثر من 10 OMS مثل Shopify وUnicommerce. بروتوكول واحد للذكاء الاصطناعي؛ تغطية كاملة لـ SMS والبريد والمدفوعات وIoT وأنظمة الطلبات.',
      learnMore: 'اعرف المزيد',
      footerLine: 'MCP · SMS · البريد · واتساب · لاين · المدفوعات · OMS · IoT · نقاط البيع · التوصيل',
    },
    demoCta: {
      title: 'شغّل وكلاء الذكاء الاصطناعي في لوجستياتك',
      subtitle: 'أكثر من 100 شركة تدير الإرسال والمسارات والاستثناءات من برج Geofleet واحد',
      ctaTrial: 'ابدأ الآن',
      ctaDemo: 'احجز عرضاً',
      noCard: 'Lite من 49$ شهرياً، تجربة مجانية 7 أيام',
      freeTrial: 'Command من 190$ شهرياً لـ10 سائقين',
      cancelAnytime: 'إلغاء في أي وقت',
    },
    faq: {
      supportLabel: 'الدعم',
      title: 'الأسئلة الشائعة',
      subtitle: 'إجابات سريعة عن Geofleet وكيفية البدء.',
      items: [
        { question: 'ما هو Geofleet؟', answer: 'Geofleet منصة توصيل وأسطول مع وكلاء ذكاء اصطناعي داخل برج التحكم. تؤتمت تعيين الناقلين والسائقين، والتخطيط الوكيلي للمسارات، وتنبيهات SLA، وسير عمل الاستثناءات — مع تتبع مباشر، وأوقات وصول متوقعة، وePOD، وتحليلات عبر المراكز والسائقين والتكاملات.' },
        { question: 'كيف أبدأ؟', answer: 'إذا كنت توصّل من موقع واحد، فابدأ مع Geofleet Lite من 49$ شهرياً مع 3 سائقين و500 طلب وتجربة مجانية لمدة 7 أيام. تضيف Lite Plus ‏(99$) تخطيط المسارات والتخصيص التلقائي وواتساب وواجهة API، وتضيف Lite Autopilot ‏(179$) ‏AI Copilot وAutopilot. وتبدأ الفرق متعددة المواقع مع Geofleet Command من 190$ شهرياً لـ10 سائقين.' },
        { question: 'هل يعمل Geofleet مع أدواتي الحالية؟', answer: 'نعم. يتكامل Geofleet مع أكثر من 10 مزودي SMS، وأكثر من 10 مزودي بريد، وأكثر من 10 بوابات دفع، وأكثر من 5,000 جهاز IoT، وأكثر من 10 OMS مثل Shopify وUnicommerce، بالإضافة إلى نقاط البيع وشركاء التوصيل. نقدم أيضاً API وwebhooks للتكاملات المخصصة.' },
        { question: 'كم تكلفة Geofleet؟', answer: 'يبدأ Geofleet Lite من 49$ شهرياً مع 3 سائقين و500 طلب من موقع واحد، وتبلغ Lite Plus ‏99$ وLite Autopilot ‏179$. ويبدأ Geofleet Command من 190$ شهرياً لـ10 سائقين و5,000 طلب على Professional، أي 19$ لكل سائق، وتبلغ Premium AI ‏29$ لكل سائق. أما Enterprise فبسعر مخصص.' },
        { question: 'هل تدعمون مواقع ومراكز متعددة؟', answer: 'نعم. Geofleet مصمم لعمليات المواقع والمناطق المتعددة. يمكنك إدارة مستودعات ومطابخ ظل ومتاجر متعددة من لوحة واحدة، مع وصول حسب الدور وتحليلات حسب الموقع وإرسال بالذكاء الاصطناعي يأخذ كل المواقع في الاعتبار.' },
        { question: 'ما نوع الدعم الذي تقدمونه؟', answer: 'نقدم دعم البريد والمساعدة داخل التطبيق والوثائق لجميع الخطط. المستويات الأعلى تتضمن دعم أولي ومديري نجاح مخصصين. يمكنك أيضاً حجز عرض أو التحدث إلى المبيعات للاحتياجات المخصصة والمؤسسات.' },
      ],
    },
  },
};
